import { Integration, WithId } from '@betterfunnel/types';
import { collection, doc, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../Firebase';
import { emptyConverter } from '../utils';
import { removeUndefinedFields } from '../utils/firestore';

export const integrationsColRef = (accountId: string) =>
  collection(db, 'accounts', accountId, 'integrations').withConverter(
    emptyConverter<Integration>(),
  );

export const getIntegrations = async (
  accountId: string,
  dynamicPageId?: string,
) => {
  const fn = httpsCallable<
    { accountId: string; dynamicPageId?: string },
    WithId<Integration>[]
  >(functions, 'integrations-listIntegrations');

  const res = await fn({
    accountId,
    ...(dynamicPageId ? { dynamicPageId } : {}),
  });

  return res.data;
};

export const createWebhookIntegration = async (
  accountId: string,
  type: 'new_lead' | 'new_event',
  name: string,
  url: string,
  objectMapping?: Record<string, any>[],
  extraHeaders?: Record<string, any>[],
  dynamicPageIds?: string[],
  authentication?: {
    type: 'apiKey';
    headerName: string;
    value: string;
  },
  eventTypes?: string[],
) => {
  const fn = httpsCallable<
    {
      accountId: string;
      type: 'new_lead' | 'new_event';
      name: string;
      url: string;
      objectMapping?: Record<string, any>[];
      extraHeaders?: Record<string, any>[];
      dynamicPageIds?: string[];
      authentication?: {
        type: 'apiKey';
        headerName: string;
        value: string;
      };
      eventTypes?: string[];
    },
    WithId<Integration>
  >(functions, 'integrations-webhooks-createWebhook');

  const res = await fn({
    accountId,
    type,
    name,
    url,
    ...(objectMapping ? { objectMapping } : {}),
    ...(extraHeaders ? { extraHeaders } : {}),
    ...(dynamicPageIds ? { dynamicPageIds } : {}),
    ...(authentication ? { authentication } : {}),
    ...(eventTypes ? { eventTypes } : {}),
  });

  return res.data;
};

export const updateIntegration = async (
  accountId: string,
  integrationId: string,
  update: any,
) => {
  return updateDoc(
    doc(integrationsColRef(accountId), integrationId),
    removeUndefinedFields(update, { undefinedTo: 'deleteField' }),
  );
};

export const duplicateWebhookIntegration = async (
  accountId: string,
  integrationId: string,
) => {
  const fn = httpsCallable<
    {
      accountId: string;
      integrationId: string;
    },
    WithId<Integration>
  >(functions, 'integrations-webhooks-duplicateWebhook');

  const res = await fn({
    accountId,
    integrationId,
  });

  return res.data;
};
